import React from 'react';
import { AlertCircle, Frown, Search, DollarSign } from 'lucide-react';
import { Section } from './ui/Section';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function ProblemSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t
  } = useLanguage();
  return <Section background="stone" id="problem" data-id="element-130">
      <div ref={ref} className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20'}`} data-id="element-131">
        <div className="text-center mb-16" data-id="element-132">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-brand-navy mb-4 uppercase" data-id="element-133">
            {t('problem', 'title1')}
            <span className="text-brand-fire" data-id="element-134">{t('problem', 'title2')}</span>
          </h2>
          <div className="w-24 h-1 bg-brand-fire mx-auto rounded-full" data-id="element-135"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-136">
          {/* Card 1 */}
          <div className="bg-white p-8 rounded-xl border-l-4 border-brand-fire shadow-md hover:translate-y-[-5px] transition-transform duration-300" data-id="element-137">
            <div className="w-12 h-12 bg-brand-fire/10 rounded-full flex items-center justify-center mb-6 text-brand-fire" data-id="element-138">
              <Frown className="w-8 h-8" data-id="element-139" />
            </div>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-140">
              <span className="text-brand-navy font-bold text-xl block mb-2" data-id="element-141">
                {t('problem', 'card1Title')}
              </span>
              {t('problem', 'card1Desc')}
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white p-8 rounded-xl border-l-4 border-brand-fire shadow-md hover:translate-y-[-5px] transition-transform duration-300" data-id="element-142">
            <div className="w-12 h-12 bg-brand-fire/10 rounded-full flex items-center justify-center mb-6 text-brand-fire" data-id="element-143">
              <Search className="w-8 h-8" data-id="element-144" />
            </div>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-145">
              <span className="text-brand-navy font-bold text-xl block mb-2" data-id="element-146">
                {t('problem', 'card2Title')}
              </span>
              {t('problem', 'card2Desc')}
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white p-8 rounded-xl border-l-4 border-brand-fire shadow-md hover:translate-y-[-5px] transition-transform duration-300" data-id="element-147">
            <div className="w-12 h-12 bg-brand-fire/10 rounded-full flex items-center justify-center mb-6 text-brand-fire" data-id="element-148">
              <DollarSign className="w-8 h-8" data-id="element-149" />
            </div>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-150">
              <span className="text-brand-navy font-bold text-xl block mb-2" data-id="element-151">
                {t('problem', 'card3Title')}
              </span>
              {t('problem', 'card3Desc')}
            </p>
          </div>
        </div>

        <div className="mt-16 text-center bg-brand-fire/5 border border-brand-fire/30 p-6 rounded-lg max-w-3xl mx-auto" data-id="element-152">
          <div className="flex items-center justify-center gap-3 mb-2 text-brand-fire font-bold text-xl uppercase font-heading" data-id="element-153">
            <AlertCircle className="w-6 h-6" data-id="element-154" />
            <span data-id="element-155">{t('problem', 'alertTitle')}</span>
          </div>
          <p className="text-slate-600" data-id="element-156">{t('problem', 'alertDesc')}</p>
        </div>
      </div>
    </Section>;
}